export { default as GaugeAggregationWidget } from "./gauge_aggregation_widget";
export { default as WidgetEditGaugeAggregation } from "./gauge_aggregation_widget_form";

import * as GaugeAggregationWidgetFactory from "./gauge_aggregation_widget_factory";

export { GaugeAggregationWidgetFactory };
